import { motion } from "framer-motion";
import { CheckCircle2, ShieldCheck, HardHat, Clock } from "lucide-react";

const HIGHLIGHTS = [
  { icon: ShieldCheck, label: "Licensed & Fully Insured" },
  { icon: HardHat, label: "In-house Crew, No Subs" },
  { icon: Clock, label: "On-time. On-budget." },
  { icon: CheckCircle2, label: "Free Written Estimate" },
];

export default function About({ content }) {
  return (
    <section id="about" className="py-24 md:py-32 bg-white" data-testid="about-section">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-14 items-center">
          <div className="lg:col-span-6 relative">
            <motion.div
              initial={{ opacity: 0, x: -30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true, amount: 0.2 }}
              transition={{ duration: 0.6 }}
              className="relative"
            >
              <img
                src="https://images.unsplash.com/photo-1580983230712-fa0be40e5b0d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200"
                alt="Our team on site"
                className="w-full h-[500px] object-cover"
              />
              <div className="absolute -bottom-8 -right-4 md:-right-10 bg-orange-600 text-white p-6 md:p-8 w-56 md:w-64">
                <div className="font-display font-black text-5xl md:text-6xl leading-none">
                  {content.years_experience}+
                </div>
                <div className="uppercase tracking-widest text-xs mt-2 font-medium">
                  Years of craftsmanship
                </div>
              </div>
            </motion.div>
          </div>

          <div className="lg:col-span-6">
            <div className="text-sm uppercase tracking-widest text-orange-600 mb-4 font-medium">
              — About MER
            </div>
            <h2 className="font-display font-black uppercase leading-[0.9] tracking-tighter text-4xl sm:text-5xl md:text-6xl text-neutral-950" data-testid="about-title">
              {content.about_title}
            </h2>
            <p className="mt-6 text-neutral-600 text-base md:text-lg leading-relaxed max-w-xl" data-testid="about-text">
              {content.about_text}
            </p>

            <div className="mt-10 grid sm:grid-cols-2 gap-4">
              {HIGHLIGHTS.map(({ icon: Icon, label }) => (
                <div key={label} className="flex items-center gap-3 border border-neutral-200 p-4">
                  <Icon className="w-5 h-5 text-orange-600 shrink-0" />
                  <span className="font-body text-sm font-medium text-neutral-800">{label}</span>
                </div>
              ))}
            </div>

            <div className="mt-10 grid grid-cols-3 gap-4 border-t border-neutral-200 pt-8">
              <div>
                <div className="font-display font-black text-4xl">{content.years_experience}+</div>
                <div className="text-xs uppercase tracking-widest text-neutral-500 mt-1">Years</div>
              </div>
              <div>
                <div className="font-display font-black text-4xl">{content.projects_completed}+</div>
                <div className="text-xs uppercase tracking-widest text-neutral-500 mt-1">Projects</div>
              </div>
              <div>
                <div className="font-display font-black text-4xl">{content.happy_clients}+</div>
                <div className="text-xs uppercase tracking-widest text-neutral-500 mt-1">Happy Clients</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
